import { render, staticRenderFns } from "./NavSolutionsList.vue?vue&type=template&id=06feb882&scoped=true&"
import script from "./NavSolutionsList.vue?vue&type=script&lang=js&"
export * from "./NavSolutionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06feb882",
  null
  
)

export default component.exports